import React from "react";
import style from "./style";
import FloatingActionButton from "@material-ui/core/Fab";
import {Save as ContentSave} from "@material-ui/icons";

const SaveButton = ({title, onClick, disabled}) => {
  return (
    <div style={style.saveButtonWrapper} onClick={disabled ? null : onClick}>
      <div style={disabled ? style.disabledTitle : style.title}>{title}</div>
      <FloatingActionButton className="" color="primary" disabled={disabled} size="small">
        <ContentSave />
      </FloatingActionButton>
    </div>
  );
};

export default SaveButton;



// WEBPACK FOOTER //
// ./src/components/SaveButton/index.jsx